import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { CentrosViewModel } from "src/app/_core/models/centros/centro.model";
import { CentroPageComponent } from "../../../pages/centro/centro.page";

@Component({
    selector: "app-centro-user-report-card",
    templateUrl: "./centro-user-report-card.component.html",
    styleUrls: ["./centro-user-report-card.component.scss"],
    standalone: false
})
export class CentroUserReportCardComponent implements OnInit, AfterViewInit {
  @Input() mainFormGroup: FormGroup;
  @Input() centro!: CentrosViewModel;
  @Input() parent: CentroPageComponent;

  constructor(public translate: TranslateService) {}

  async ngAfterViewInit(): Promise<void> {
    await this.parent.loadValues();
  }

  // Events
  ngOnInit(): void {}

  getCentroUserReportFormGroup(): FormGroup {
    return this.mainFormGroup?.get("centroUserReport") as FormGroup;
  }
}
